import { ref, watchEffect } from 'vue'
import type { InventTab } from '@/entities/Manuals/Tabs'
import { useLoadTabs } from '@/entities/Manuals/Tabs/model/api.ts'
import { useTranslate } from '@/shared/lib'

export const useModel = () => {
  const { trs } = useTranslate()

  const data = ref<InventTab[]>([])

  /**
   * Настройки шапки формы
   */
  const headers = ref([
    { title: '#', key: 'id', sortable: false },
    { title: trs('itf.name'), key: 'name', sortable: false },
    { title: trs('itf.icon'), key: 'icon', sortable: false },
    { title: trs('itf.is_interface_show'), key: 'is_show', sortable: false },
    { title: trs('itf.is_mobile_show'), key: 'is_mobile', sortable: false },
    { title: trs('itf.action'), key: 'action', sortable: false },
  ])

  /**
   * Функция загрузки данных
   */
  const loadData = () => {
    const result = useLoadTabs()

    watchEffect(() => {
      if (result.data.value) {
        data.value = result.data.value.data || []
      }
    })

    return result
  }

  return {
    data,
    headers,

    loadData,
  }
}
